import { createApp } from 'vue'
import App3 from '@vue3/App.vue'
import router from '@vue3/router/index.js'
import pinia from '@vue3/store/init'
import i18n from '@vue3/i18n'
import '@blibli/blue-font/dist/_blue-font-blibli.scss'
import '@blibli/blue-dls-utils/dist/scss/_box-sizing-helper.scss'
import '@vue3/assets/styles/global.scss'
import BliToast from '@blibli/blue.toast/dist/toast/blue/toast-index'
import { createGtm } from '@gtm-support/vue-gtm'
import TrackerMixins from '@vue3/mixins/trackerMixins'
import { initializeFirebaseNotifications } from '@vue3/firebase'

export function start () {
  const app = createApp(App3)
  app.use(router)
  app.use(pinia)
  app.use(i18n)
  app.use(
    createGtm({
      id: 'GTM-KD7C4XNW'
    })
  )
  app.mixin(TrackerMixins)
  app.mount('#app3')
  app.config.globalProperties.$toast = BliToast

  initializeFirebaseNotifications()
}
